import { render, staticRenderFns } from "./ForumDate.vue?vue&type=template&id=730537da&"
import script from "./ForumDate.vue?vue&type=script&lang=js&"
export * from "./ForumDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports